import { useState } from 'react';
import { addEssentialsListToCart } from './addEssentialsListToCart.js';
import { LoadingEllipsis } from './LoadingEllipsis.js';
import { refreshMiniCartFromDetailsObject } from '../general/module/miniCartFunctions';

const SuccessButton = ({ children, href }) => {
    return <a className="button-secondary small full-width" href={href}>{children}</a>;
};

const states = {
    READY: 'READY',
    REQUEST_PENDING: 'REQUEST_PENDING',
    SUCCESS: 'SUCCESS',
};

/**
 * Extracted from {@link EssentialsListCard} and {@link EssentialsListPromo}. Makes an AJAX-request to add an
 * essentials-list-donation to your cart.
 */
export const EssentialsListDonateButton = ({ teacherId, topItemPrice, children }) => {
    const [status, setStatus] = useState(states.READY);

    const onSuccess = (data) => {
        // TODO: do we want to use ajaxAddToCartSubmit here? It does a bunch of stuff, but some might be project specific

        // make sure minicart gets updated using general/miniCartFunctions.js
        if (data && data.sessionMiniCartDetails) {
            refreshMiniCartFromDetailsObject(data.sessionMiniCartDetails);
        }
        setStatus(states.SUCCESS);
    };
    const onFailure = () => {
        setStatus(states.READY);
        window.toast('Something went wrong!');
    };

    const onClick = (e) => {
        e.preventDefault();
        setStatus(states.REQUEST_PENDING);
        addEssentialsListToCart(teacherId, topItemPrice, onSuccess, onFailure);
    };

    if (status === states.SUCCESS) {
        return <SuccessButton href={secureBaseURL + 'donors/givingCart.html'}>Added! Check out</SuccessButton>;
    }

    if (status === states.REQUEST_PENDING) {
        return <LoadingEllipsis />;
    }

    return (
        <button className="button-primary small essentials" onClick={onClick}>
            {children}
        </button>
    );
};
